<template>
  <div>
    <div style="height: 65px;"/>
    <Progress :current-stage="currentStage"/>
    <div style="height: 65px;"/>
    <CreateOrder v-if="order == null"  @orderData="createOrder"/>
    <PaymentOrder v-if="order != null" :order="order" />
    <div style="height: 65px;"/>
  </div>
</template>

<script>
import Progress from "../components/Progress";
import CreateOrder from "./buy/CreateOrder";
import PaymentOrder from "./buy/PaymentOrder";


export default {
  name: "Buy",
  components: {Progress, CreateOrder, PaymentOrder},
  data() {
    return {
      currentStage: 1,
      count: 1,
      order: null,
    };
  },
  created() {
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    createOrder(data) {
      this.order = data;
      this.currentStage = 3;
    },
  },
}
</script>

<style lang="scss" scoped>


</style>
